import React, { useRef, useState } from 'react' // 1. useState eklendi
import './contact.css'
import {MdOutlineMail, MdCheckCircleOutline, MdErrorOutline} from 'react-icons/md'
import emailjs from 'emailjs-com'

const Contact = () => {
  const form = useRef();
  
  // 2. Mesaj durumu için state (null, 'success' veya 'error')
  const [messageStatus, setMessageStatus] = useState(null);

  const sendEmail = (e) => {
    e.preventDefault();

    // Gönderiliyor hissiyatı vermek için state'i sıfırla
    setMessageStatus(null); 

    emailjs.sendForm('service_batcq12', 'template_5az3w7g', form.current, 'uGqiyktdwU5F_DX94')
      .then((result) => {
          console.log(result.text);
          // BAŞARILI OLURSA
          setMessageStatus('success');
          e.target.reset(); // Formu temizle
          
          // 5 saniye sonra mesajı kaldır
          setTimeout(() => setMessageStatus(null), 10000);
      }, (error) => {
          console.log(error.text);
          // HATA OLURSA
          setMessageStatus('error');
          
           // 7 saniye sonra mesajı kaldır
           setTimeout(() => setMessageStatus(null), 10000);
      });
  };

  return (
    <section id='contact'>
      <h5>Get In Touch</h5>
      <h2>Contact Me</h2>

      <div className="container contact_container">
        <div className="contact_options">
          <article className='contact_option'>
            <MdOutlineMail className='contact_option-icon'/>
            <h4>Email</h4>
            <h5>bilgehancomert@gmail.com</h5>
            <a href="mailto:bilgehancomert@gmail.com" target="_blank" rel="nofollow noreferrer">Send a message</a>
          </article>
        </div>
        
        <form ref={form} onSubmit={sendEmail}>
          <input type="text" name='name' placeholder='Your Full Name' required/>
          <input type="email" name='email' placeholder='Your Email' required />
          <textarea name="message" rows="7" placeholder='Your Message' required></textarea>

          {messageStatus === 'success' && (
            <div className="form_message success" role="status" aria-live="polite">
              <MdCheckCircleOutline className="form_message-icon" aria-hidden="true" />
              <p>
                <strong>Message sent.</strong> Thanks for reaching out, I'll get back to you as soon as possible.
              </p>
            </div>
          )}

          {messageStatus === 'error' && (
            <div className="form_message error" role="alert">
              <MdErrorOutline className="form_message-icon" aria-hidden="true" />
              <p>
                <strong>Something went wrong.</strong> Your message couldn't be sent. Please email me directly or reach me on <a href="https://www.linkedin.com/in/bilgehan-comert/" target="_blank" rel="noreferrer">LinkedIn</a>.
              </p>
            </div>
          )}

          <button type='submit' className='btn btn-primary'> Send Message</button>
        </form>
      </div>
    </section>
  )
}

export default Contact